import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold text-background-50 font-heading">
                  蘑菇视频
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-background-400">
                蘑菇视频是一款深受用户喜爱的短视频娱乐平台，海量高清视频内容随心看。发现精彩，分享快乐。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200" aria-label="B站">
                  <i className="ri-bilibili-line text-background-300 hover:text-background-50 text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/" className="hover:text-primary-400 transition-colors">热门频道</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/gaoxiao', label: '搞笑' },
                  { to: '/category/meishi', label: '美食' },
                  { to: '/category/shenghuo', label: '生活' },
                  { to: '/category/shishang', label: '时尚' },
                  { to: '/category/lvxing', label: '旅行' },
                  { to: '/category/keji', label: '科技' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-sm text-background-400 hover:text-background-200 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">品牌介绍</a></li>
                <li><a href="/about#reputation" className="text-sm text-background-400 hover:text-background-200 transition-colors">用户口碑</a></li>
                <li><a href="/about#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors">联系我们</a></li>
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors">帮助中心</Link></li>
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors">用户协议</Link></li>
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors">隐私政策</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">下载蘑菇视频App</h4>
              <p className="text-sm text-background-400 mb-4 leading-relaxed">
                随时随地看精彩短视频，发现更多有趣内容
              </p>
              <div className="flex flex-col gap-2.5">
                <a
                  href="#download"
                  className="flex items-center gap-2 px-4 py-2.5 bg-background-800 hover:bg-background-700 rounded-lg text-sm text-background-200 transition-colors cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  <span>iOS 版本下载</span>
                </a>
                <a
                  href="#download"
                  className="flex items-center gap-2 px-4 py-2.5 bg-background-800 hover:bg-background-700 rounded-lg text-sm text-background-200 transition-colors cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  <span>Android 版本下载</span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 蘑菇视频 moguvideo.com 版权所有 | 京ICP备xxxxxxxx号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">Cookie设置</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}